"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CheckCircle_exports = {};
__export(CheckCircle_exports, {
  default: () => CheckCircle_default
});
module.exports = __toCommonJS(CheckCircle_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M24 12.0042C24 18.6212 18.617 24.0042 12 24.0042C5.383 24.0042 0 18.6212 0 12.0042C0 5.38715 5.383 0.00415039 12 0.00415039C18.617 0.00415039 24 5.38715 24 12.0042ZM22 12.0042C22 6.49015 17.514 2.00415 12 2.00415C6.486 2.00415 2 6.49015 2 12.0042C2 17.5182 6.486 22.0042 12 22.0042C17.514 22.0042 22 17.5182 22 12.0042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M15.8767 8.00843C14.0206 10.2342 12.9799 11.4822 11.1237 13.708C11.0308 13.8012 10.9204 13.8752 10.7988 13.9257C10.6772 13.9763 10.5469 14.0022 10.4152 14.0022C10.2836 14.0022 10.1532 13.9763 10.0316 13.9257C9.91003 13.8752 9.79962 13.8012 9.70671 13.708L8.08751 12.5087C7.9946 12.4154 7.88419 12.3414 7.7626 12.2909C7.64102 12.2404 7.51066 12.2144 7.37901 12.2144C7.24736 12.2144 7.117 12.2404 6.99542 12.2909C6.87383 12.3414 6.76342 12.4154 6.67051 12.5087C6.57723 12.6016 6.50322 12.712 6.45272 12.8336C6.40222 12.9552 6.37622 13.0855 6.37622 13.2172C6.37622 13.3488 6.40222 13.4792 6.45272 13.6008C6.50322 13.7223 6.57723 13.8328 6.67051 13.9257L8.29171 15.121C8.85565 15.6839 9.6199 16 10.4167 16C11.2135 16 11.9778 15.6839 12.5417 15.121C14.3975 12.8963 15.4379 11.6491 17.2937 9.42443C17.3869 9.33154 17.4607 9.22119 17.5111 9.0997C17.5616 8.9782 17.5875 8.84796 17.5875 8.71643C17.5875 8.58489 17.5616 8.45465 17.5111 8.33316C17.4607 8.21167 17.3869 8.10132 17.2937 8.00843C17.2008 7.91515 17.0904 7.84114 16.9688 7.79064C16.8472 7.74014 16.7169 7.71414 16.5852 7.71414C16.4536 7.71414 16.3232 7.74014 16.2016 7.79064C16.08 7.84114 15.9696 7.91515 15.8767 8.00843Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgCheckCircle = SvgIcon;
var CheckCircle_default = SvgCheckCircle;
//# sourceMappingURL=CheckCircle.js.map